import Contact from "../containers/Contact/Contact"
import {injectIntl} from 'react-intl'; 
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { sendContactUsMail } from '../store/actions/common';

const mapDispatchToProps = dispatch => {
    return {
        onSendMail: (name, email, message) => dispatch(sendContactUsMail(name, email, message))
    };
}

const mapStateToProps = state => {
    return {};
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(injectIntl(Contact)));